export default {
  nome: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/positionmodel.js